(function () {
  "use strict";

  angular
    .module("trainerWebApp.directives")
    .directive("mfEditGroupUsersSidebar", mfEditGroupUsersSidebar);

  function mfEditGroupUsersSidebar() {
    return {
      restrict: "A",
      link: function ($scope, elem, attrs) {
        var select = $("#inputUsersMultiple");

        var opts = $scope.selectUsersOptions;

        opts.formatResult = function (object, container, query) {

          if (object.children) {
            container[0].innerHTML = '<span>' + object.text + '</span>';
            return;
          }

          var term = $.trim(query.term || "");
          var html = '<div title="' + object.text + '" >';

          if (object.label && !object.hideLabelInDropDown)
            html = html + '<span>' + object.label + ': </span>';
          var startOfCriteriaInResult = object.text.toLowerCase().indexOf(term.toLowerCase());


          if (startOfCriteriaInResult > 0)
            html = html + '<span>' + object.text.substr(0, startOfCriteriaInResult) + '</span>';
          else
            startOfCriteriaInResult = 0;

          html = html + '<span class="select2-match">' + object.text.substr(startOfCriteriaInResult, term.length) + '</span>';
          if (object.text.length > startOfCriteriaInResult + term.length) {
            var startOfRestOfResult = startOfCriteriaInResult + term.length;
            html = html + '<span>' + object.text.substr(startOfRestOfResult, object.text.length - startOfRestOfResult) + '</span>';
          }

          html = html + '</div>';
          container[0].innerHTML = html;
        };

        select.select2(opts);

        select.on("select2-selecting", function (event) {
          $scope.$apply(function () {
            $scope.addUser(event.object, function (reopen) {
              clearInput(reopen);
            });
          });

          event.preventDefault();
        });

        function clearInput(reopen) {
          var searchInput = elem.find('.select2-input');
          select.select2('close');
          searchInput.val('');
          searchInput.removeClass("select2-default");
          if (reopen) {
            select.select2('open');
          }
        }

        select.on("select2-open", function (event) {
          $('.select2-dropdown-size-hack').removeClass('select2-dropdown-size-hack');
        });

        $scope.forceCloseDropDown = function () {
          select.select2('close');
        };

        $scope.$on('$destroy', function () {
          $scope.forceCloseDropDown();
        });
      }
    }
  }

})();
